module.exports = __webpack_public_path__ + "img/Terror.9035b492.svg";